import { RouletteSlot } from "../components/RouletteSlot";
import { orientation } from "../utils";
import AnimationManager from "./AnimationManager";

const INITIAL_CLIP_PATH_FRAME = {
  opacity: 1,
  clipPath:
    "polygon(100% 0%, 100% 100%, 87.5% 100%, 75% 100%, 62.5% 100%, 50% 100%, 37.5% 100%, 25% 100%, 12.5% 100%, 0% 100%, 0% 0%)",
};

const MID_CLIP_PATH_WIDE_FRAME = {
  clipPath:
    "polygon(100% 0%, 100% 100%, 91.93% 50%, 80.89% 25%, 66.24% 10%, 50% 5%, 31.11% 10%, 16.9% 25%, 6.53% 50%, 0% 100%, 0% 0%)",
};

const FINAL_CLIP_PATH_TALL_FRAME = {
  clipPath:
    "polygon(100% 0%, 100% 67.83%, 91.93% 57%, 80.89% 48%, 66.24% 42%, 50% 40%, 31.11% 42%, 16.9% 48%, 6.53% 57%, 0% 67.83%, 0% 0%)",
};

const FINAL_CLIP_PATH_FRAME = {
  opacity: 0,
  clipPath:
    "polygon(100% 0%, 100% 35.66%, 91.93% 21.65%, 80.89% 10.19%, 66.24% 3.95%, 50% 0%, 31.11% 3.93%, 16.9% 10.19%, 6.53% 21.65%, 0% 35.66%, 0% 0%)",
};

export default class Transition {
  public static blur = AnimationManager.create(
    [{ filter: `blur(2vh)`, transform: `scale(0.92)` }],
    { easing: "linear" }
  );

  public static unblur = AnimationManager.create(
    [{ filter: `blur(0)`, transform: `scale(1)` }],
    { easing: "linear" }
  );

  public static circularFadeOut = AnimationManager.create(
    (element) => {
      element.style.boxShadow = "0 0 5vh 10vh #555";
      return [
        INITIAL_CLIP_PATH_FRAME,
        orientation() == "landscape" ? MID_CLIP_PATH_WIDE_FRAME : FINAL_CLIP_PATH_TALL_FRAME,
        FINAL_CLIP_PATH_FRAME,
      ];
    },
    {
      duration: 800,
      easing: "ease-out",
    }
  );

  public static fadeIn = AnimationManager.create([{ opacity: 1 }]);

  public static fadeOut = AnimationManager.create([{ opacity: 0 }], {
    easing: "ease-out",
  });

  public static fadeScaleIn = AnimationManager.create([
    { transform: "scale(1)" },
  ]);

  public static async replace(
    element: HTMLElement,
    newElement: HTMLElement,
    config?: KeyframeAnimationOptions
  ): Promise<Animation> {
    const duration = (config?.duration as number) / 2 || 250;

    await this.fadeOut(element, { duration }).finished;
    element.classList.add("hidden");

    newElement.style.display = "block";
    return this.fadeIn(newElement, { duration });
  }

  public static scaleOut = AnimationManager.create(
    (element) => {
      const { innerHeight, innerWidth } = window;
      const windowRatio = innerWidth / innerHeight;

      let scaleRatio = (innerHeight * 2) / element.clientHeight;
      if (orientation() === "landscape") scaleRatio *= windowRatio;

      return [{ transform: `scale(${scaleRatio})` }];
    },
    {
      duration: 400,
      easing: "linear",
    }
  );
}
